import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="text-center mb-8">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
              影迷投稿 · 资源合作 · 商务洽谈
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-8">
            {contactInfo.tips.map((tip) => (
              <div
                key={tip}
                className="flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-lg text-sm text-foreground-700"
              >
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                {tip}
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href={`mailto:${contactInfo.email}`}
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              发送邮件联系我们
            </a>
            <p className="text-xs text-foreground-400 mt-4">{contactInfo.email}</p>
          </div>
        </div>
      </div>
    </section>
  );
}